export default __webpack_public_path__ + "static/media/rr-mp-popup.694acd10.jpg";